module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "ded"
  }, [_c('p', {
    staticClass: "newchap",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "MOOnshine-thunder-rOad--and-mOuntain-elixirs"
    }
  }), _vm._v("Moonshine “Thunder Road,” and Mountain Elixirs")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "_idGenPageitem-1",
    attrs: {
      "alt": "",
      "src": "image/purple_wine.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "ded"
  }, [_c('p', {
    staticClass: "subTOC"
  }, [_c('a', {
    attrs: {
      "href": "#/#Ode-to-Muddy-Pond"
    }
  }, [_vm._v("Ode to Muddy Pond")])]), _vm._v(" "), _c('p', {
    staticClass: "subTOC"
  }, [_c('a', {
    attrs: {
      "href": "#/#Lohito"
    }
  }, [_vm._v("Lohito")])]), _vm._v(" "), _c('p', {
    staticClass: "subTOC"
  }, [_c('a', {
    attrs: {
      "href": "#/#Cool-as-a-Cucumber"
    }
  }, [_vm._v("Cool as a Cucumber")])]), _vm._v(" "), _c('p', {
    staticClass: "subTOC"
  }, [_c('a', {
    attrs: {
      "href": "#/#The-Pickled-Okra"
    }
  }, [_vm._v("The Pickled Okra")])]), _vm._v(" "), _c('p', {
    staticClass: "subTOC"
  }, [_c('a', {
    attrs: {
      "href": "#/#Appalachian--Limoncello"
    }
  }, [_vm._v("Appalachian Limoncello")])]), _vm._v(" "), _c('p', {
    staticClass: "subTOC"
  }, [_c('a', {
    attrs: {
      "href": "#/#Fireplace-Hot--Cocoa-Mix"
    }
  }, [_vm._v("Fireplace Hot Cocoa Mix")])]), _vm._v(" "), _c('p', {
    staticClass: "subTOC"
  }, [_c('a', {
    attrs: {
      "href": "#/#Rosemary-Peach-Lemonade"
    }
  }, [_vm._v("Rosemary Peach Lemonade")])]), _vm._v(" "), _c('p', {
    staticClass: "subTOC"
  }, [_c('a', {
    attrs: {
      "href": "#/#Paris-of-the-South"
    }
  }, [_vm._v("Paris of the South")])]), _vm._v(" "), _c('p', {
    staticClass: "subTOC"
  }, [_c('a', {
    attrs: {
      "href": "#/#Tupelo-Honey-Molasses-Eggnog"
    }
  }, [_vm._v("Tupelo Honey–Molasses Eggnog")])])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "chquote"
  }, [_c('a', {
    attrs: {
      "id": "cbs"
    }
  }), _vm._v("Whiskey isn’t the only thing that’s been distilled in these hills. The people are a distillation too, a boiling down of good Scots-Irish stock, refined by mountain summers and winters, and condensed by hard times.  ")]), _vm._v(" "), _c('p', {
    staticClass: "chquoteatt"
  }, [_vm._v("—Charles Kuralt, CBS News Sunday Morning")]), _vm._v(" "), _c('p', {
    staticClass: "basic"
  }), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_c('span', {
    staticClass: "orangecap"
  }, [_vm._v("T")]), _vm._v("he mountain South is proud of its legacy as fountainhead for two important American pastimes: moonshine and NASCAR. The two traditions are inextricably linked, since “navigating curvy mountain roads at 100 miles per hour in order to elude the authorities trying to nail you for the still you have behind your barn” is where it all began. All you need to do is conjure up Robert Mitchum right now, humming “The Ballad of Thunder Road.” ")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("Today, good, modern moonshine not only is legalized but has been elevated to the rather highfalutin designation of an artisanal spirit. Heirloom corn, German-made stills, mountain water, and small-batch craft distilling all contribute to the idea of a white whiskey that is handmade and high end. In other words, this isn’t your cousin Joe’s corn likker. Southern mixologists are infusing shine with everything from lemongrass to smoky oak and creating craft Southern spirits and innovative cocktails that defy description. At Tupelo Honey, for example, one of our customers’ favorites at Sunday brunch is our Moonswine Mary, made with house-infused bacon and jalapeño moonshine. ")]), _vm._v(" "), _c('p', {
    staticClass: "chtext"
  }, [_vm._v("Southerners have always been serious about their five o’clock beverage of choice, from mint juleps to single-barrel bourbon. Modern barkeeps in the South—and certainly in the mountain South—are truly raising the bar with creative, whimsical concoctions that delight and amuse, from corpse revivers to classic martinis. At Tupelo Honey, our bar menu is chef-driven, just like our food, and we pride ourselves on our assortment of tongue-tingling, taste bud–tempting, cocktail twistification. We just don’t believe in mediocrity when it comes to food and drink. Come out on a limb with us and try some amazing beverages like "), _c('a', {
    attrs: {
      "href": "#/#Ode-to-Muddy-Pond"
    }
  }, [_vm._v("Ode to Muddy Pond")]), _vm._v(", our tip of the hat to good bourbon and Muddy Pond Sorghum from Tennessee. Or try our Pickled Okra made with bacon and jalapeño–infused moonshine. (Don’t worry if you can’t find moonshine. Vodka works too!) Be adventuresome on the blank canvas of your bar glass. And then stand tall when people clamor for invitations to your memorable cocktail parties. ")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "rectitle"
  }, [_c('a', {
    attrs: {
      "id": "Ode-to-Muddy-Pond"
    }
  }), _c('span', {
    staticClass: "orange"
  }, [_vm._v("Ode to Muddy Pond")])]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("Grown, harvested, and produced in the hills of Tennessee, just west of Knoxville, Muddy Pond Sorghum is 100 percent sorghum, with no additives. The Guenther family makes this delicious amber elixir, and we salute them—and their delicious sorghum—by adding a little bourbon.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Makes 1 cocktail")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("3 fresh basil leaves, plus additional for garnish")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("½ ounce sorghum molasses")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("1¼ ounces Maker’s Mark")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Iced ginger ale")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("Muddle the 3 basil leaves with the molasses in a high ball glass. Add the Maker’s Mark and ice and stir. Top with the ginger ale and a basil leaf for garnish. ")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "SBT"
  }, [_vm._v("Across the mountain South, folks have learned, as is true with most things, when it comes to access to libations, necessity is the mother of invention. As a result, innovative mountaineers have long enjoyed imbibing homemade fruit brandies, wines, and beers, such as June apple brandy, cherry bounce, peach brandy, elderberry wine, syllabub or “bubs,” pokeberry wine, scuppernong wine, and spruce and persimmon beer. ")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "rectitle"
  }, [_c('a', {
    attrs: {
      "id": "Lohito"
    }
  }), _c('span', {
    staticClass: "orange"
  }, [_vm._v("Lohito")])]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("We like to infuse our moonshine with different flavors to give traditional cocktails our own interpretation. Here, we infuse the hooch with lemongrass. The result is a white whiskey with a touch of exotic citrus. ")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Makes 1 cocktail")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Zest of 1 lemon mixed with 3 tablespoons sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Freshly squeezed juice from 1 lemon, plus a lemon wedge for serving")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("3 fresh mint leaves, plus a sprig for garnish")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("1½ ounces "), _c('a', {
    attrs: {
      "href": "#/52249txt1#Lemongrass-Moonshine"
    }
  }, [_vm._v("Lemongrass Moonshine")])])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("1 bar spoon tupelo honey")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("½ ounce "), _c('a', {
    attrs: {
      "href": "#/52249txt1#Mint-Simple-Syrup"
    }
  }, [_vm._v("Mint Simple Syrup")])])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Ice")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Soda water")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("Rim a 10-ounce Collins glass with the lemon sugar and set aside. Muddle the lemon juice and mint leaves together in a shaker. Add the moonshine, honey, syrup, and ice. Shake and pour into the lemon sugar–rimmed glass. Top with soda water, and garnish with the mint sprig and lemon wedge. ")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "rectitle"
  }, [_c('a', {
    attrs: {
      "id": "Lemongrass-Moonshine"
    }
  }), _c('span', {
    staticClass: "orange"
  }, [_vm._v("Lemongrass Moonshine")])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Makes 3¼ cups")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("3 large bulbs lemongrass")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("One 759 ml bottle of moonshine")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("Thoroughly wash the lemongrass and cut the bulbs into quarters around 6 inches long. Discard the stalks. Combine all ingredients in an airtight container and let the mixture rest for 5 days. On the fifth day, strain the lemongrass and transfer the infused whisky to a decorative bottle. This is delicious in our Lohito or served as a stand-along cocktail on the rocks. ")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "rectitle"
  }, [_c('a', {
    attrs: {
      "id": "Mint-Simple-Syrup"
    }
  }), _c('span', {
    staticClass: "orange"
  }, [_vm._v("Mint Simple Syrup")])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Makes 1 cup")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("1 cup sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("¾ cup light corn syrup")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("1 cup water")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("2 ounces fresh mint, stems and leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("Combine the sugar, corn syrup, water, and mint in a pan over low heat and simmer the mixture until it reduces by half. Remove the pan from the heat and allow to steep for 20 minutes. Strain the mint from the syrup and transfer the simple syrup to an airtight container. The syrup may be stored in the refrigerator for up to 3 months. ")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "_idGenPageitem-1",
    attrs: {
      "alt": "",
      "src": "image/IMG_2213.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "rectitle"
  }, [_c('a', {
    attrs: {
      "id": "Cool-as-a-Cucumber"
    }
  }), _c('span', {
    staticClass: "orange"
  }, [_vm._v("Cool as a Cucumber")])]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("When it’s hot as blazes outside, this cocktail is best enjoyed in a rocking chair on the front porch in the shade. Cucumbers, with their extremely high water content, are nature’s version of a vegetable air conditioner. A splash of pineapple will transport you (in your mind, at least) to your own private tropical island.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Makes 1 cocktail")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("6 strips cucumber, sliced lengthwise with a vegetable peeler")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Two 2-inch slices peeled cucumber, plus a slice for garnish ")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("1 lime wedge")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("1¼ ounces gin")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("¾ ounce St-Germaine")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("½ ounce Malibu")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("½ ounce pineapple juice")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Crushed ice ")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Tonic water")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("Finely dice the cucumber slices. Muddle the cucumber and lime wedge in a 10-ounce Collins glass. Add the gin, St-Germaine, Malibu, and pineapple juice. Add the crushed ice and top with the tonic water. Garnish with a slice of cucumber and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "_idGenPageitem-1",
    attrs: {
      "alt": "",
      "src": "image/TH_02_Cool_as_Cucumber_026jb.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "rectitle"
  }, [_c('a', {
    attrs: {
      "id": "The-Pickled-Okra"
    }
  }), _c('span', {
    staticClass: "orange"
  }, [_vm._v("The Pickled Okra")])]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("We named our bar The Pickled Okra, and this seductive cocktail does the name justice. It uses our jalapeño and bacon–infused moonshine, as does our Moonswine Mary, an inventive twist on the Bloody Mary that is so unusually delicious we’ve trademarked it.  ")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Makes 1 cocktail")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("2 ounces Jalapeño-Bacon Moonshine (recipe follows)")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("1 ounce olive juice ")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Ice")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Pimento cheese–stuffed olives, for serving")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("In a shaker, combine the Jalapeño-Bacon Moonshine and olive juice. Add the ice, shake, and strain into a martini glass. Make a batch of our pimento cheese "), _c('a', {
    attrs: {
      "href": "#/52249txt2#Pimento-Cheese-with-a-Kick"
    }
  }, [_vm._v("(Pimento Cheese with a Kick)")]), _vm._v(" and use it to stuff large olives. Serve with pimento cheese–stuffed olives on toothpicks.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "rectitle"
  }, [_c('a', {
    attrs: {
      "id": "Jalape-o-Bacon-Moonshine"
    }
  }), _c('span', {
    staticClass: "orange"
  }, [_vm._v("Jalapeño-Bacon Moonshine")])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Makes 3½ cups")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("2 poblano peppers")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("2 jalapeño peppers")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("10 strips fully cooked bacon")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("One 750 ml bottle of moonshine (or vodka or gin)")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("Wearing rubber gloves to protect your skin, slice off the tops of the peppers and remove the seeds. Place the peppers flat skin side up on a foil-lined rimmed baking sheet and put the pan under the stove broiler. Broil until the skin of the peppers is charred and black. Remove the peppers from the oven and transfer them to a ziplock bag. The steam will help loosen the skin of the peppers and make it easier to remove. ")]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("After removing the skin, cut the peppers into quarters and place in an airtight container. Place the cooked bacon in the container and pour the moonshine over the peppers and bacon, ensuring that the ingredients are completely covered. Seal the container and allow to infuse for six days, stirring daily. After six days, strain the whiskey over a colander. Squeeze out any additional liquid from the peppers and bacon and add this to the infusion. Place the mixture in the freezer for at least one hour and then strain the liquid through a coffee filter. You may want to strain the liquid twice to remove all solids. ")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "_idGenPageitem-1",
    attrs: {
      "alt": "",
      "src": "image/IMG_2361.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "rectitle"
  }, [_c('a', {
    attrs: {
      "id": "Appalachian--Limoncello"
    }
  }), _c('span', {
    staticClass: "orange"
  }, [_vm._v("Appalachian Limoncello")])]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("We use this deliciously lemony limoncello in our version of a Pimm’s Cup, a classic Southern cocktail (adapted from British versions) for summer afternoons. If you mix your Pimm’s No. 1 with champagne instead of our limoncello, you have a Pimm’s Royale. La-de-dah!")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Makes about 3 cups")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Zest of 10 lemons")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("1 bottle (750 ml) vodka")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("2 cups sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("3½ cups hot water")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("Combine the lemon zest and vodka in an airtight container for 4 days. On the fifth day, make a simple syrup by combining the sugar and hot water. Add the simple syrup to the vodka mixture, and cover again. Allow the flavors to meld overnight and then strain out the solids using a fine-mesh strainer. Keep the limoncello in your freezer for up to one year so you can always serve it cold. ")]), _vm._v(" "), _c('div', {
    staticClass: "ded"
  }, [_c('p', {
    staticClass: "chquote"
  }, [_c('a', {
    attrs: {
      "id": "ham1"
    }
  }), _vm._v("Traditional at Appalachian corn shuckings, where communities would get together to help one another with harvesting corn, the host would stash a jug of whisky deep in the unshucked corn pile. The first shucker to reach the errant red ear won three swigs from the jug, or as mountain folks put it, “three bobs of his Adam’s apple.” Finding the red ear also meant the finder could kiss the girl of his choosing.")]), _vm._v(" "), _c('p', {
    staticClass: "chquoteatt"
  }, [_vm._v("—Joe Dabney\t")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "rectitle"
  }, [_c('a', {
    attrs: {
      "id": "Fireplace-Hot--Cocoa-Mix"
    }
  }), _c('span', {
    staticClass: "orange"
  }, [_vm._v("Fireplace Hot Cocoa Mix")])]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("Cuddle up next to the woodstove or fireplace or your radiator at home with this nod to tradition. The ingredients can be mixed and stored in an airtight container in a cool, dry place so instant gratification is only a few tablespoons away. ")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Makes 4½ cups, or about 10 servings")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("2 cups powdered sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("2½ cups dry milk powder")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("1 cup unsweetened cocoa powder")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("2 teaspoons cornstarch")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("2 teaspoons salt")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Pinch of cayenne pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("Combine the powdered sugar, dry milk powder, cocoa powder, cornstarch, salt, and cayenne pepper in a large bowl and stir with a wire whisk until the ingredients are well blended. Store in an airtight container in a cool, dry place for up to 6 months. To make the cocoa, place ¼ cup of the mixture in a big mug, pour in ¾ cup of boiling water, and stir well. Enjoy! ")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "mix"
    }
  }), _c('img', {
    staticClass: "_idGenPageitem-1",
    attrs: {
      "alt": "",
      "src": "image/iStock_000001203724Medium.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "rectitle"
  }, [_c('a', {
    attrs: {
      "id": "Rosemary-Peach-Lemonade"
    }
  }), _c('span', {
    staticClass: "orange"
  }, [_vm._v("Rosemary Peach Lemonade")])]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("This is Tupelo Honey’s signature lemonade and we have folks who come into the restaurant just to get their fix on occasion. The addition of rosemary lends an aromatic savory note to the sweet peach nectar, and the tart fresh lemon juice balances everything out.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Makes 5¾ cups, or 4 servings")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("1½ cups peach nectar")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("1½ cups water")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("1¼ cups Rosemary Simple Syrup (recipe follows)")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("1 cup freshly squeezed lemon juice")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("In a 2-quart container, combine the peach nectar, water, simple syrup, and lemon juice. Stir well. Cover and refrigerate until well chilled before serving. ")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "rectitle"
  }, [_c('a', {
    attrs: {
      "id": "Rosemary-Simple-Syrup"
    }
  }), _c('span', {
    staticClass: "orange"
  }, [_vm._v("Rosemary Simple Syrup")])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Makes 1¾ cups")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("1"), _c('span', {
    staticClass: "super"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "sub"
  }, [_vm._v("3")]), _vm._v(" cups water")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("1 cup sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("4 (5-inch) stalks fresh rosemary")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("Combine the water, sugar, and rosemary in a medium saucepan and bring to a boil over medium heat, stirring until the sugar is dissolved. Pour the syrup through a fine-mesh strainer into a container to remove the rosemary stalks and leaves. Let the syrup cool, and store in an airtight container in the refrigerator for up to 1 week. ")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "_idGenPageitem-1",
    attrs: {
      "alt": "",
      "src": "image/TH_01_Rosemary_Peach_Lemonade_v1_002.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "rectitle"
  }, [_c('a', {
    attrs: {
      "id": "Paris-of-the-South"
    }
  }), _c('span', {
    staticClass: "orange"
  }, [_vm._v("Paris of the South")])]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("Because of its artistic, creative, and slightly quirky bent, Asheville, North Carolina, is sometimes referred to as the Paris of the South. Here’s a toast to Ashevegas! ")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Makes 1 cocktail")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("1 ounce Bulleit Rye")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("1½ ounces St-Germaine")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("2 tablespoons freshly squeezed lemon juice")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("2 dashes of bitters")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Ice")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Ginger ale (we love Blenheim)")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Twist of lemon")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("Combine the rye, St-Germaine, lemon juice, and bitters with ice in a cocktail shaker. Gently shake and then strain off the liquid into a highball glass. Top with ginger ale and a twist of lemon. ")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "rectitle"
  }, [_c('a', {
    attrs: {
      "id": "Tupelo-Honey-Molasses-Eggnog"
    }
  }), _c('span', {
    staticClass: "orange"
  }, [_vm._v("Tupelo Honey–Molasses Eggnog")])]), _vm._v(" "), _c('p', {
    staticClass: "headnote"
  }, [_vm._v("In the South, eggnog is generally consumed over Christmas and New Year’s with the addition of some fine bourbon thrown in. This recipe is delicious with or without the hooch. Freshly ground nutmeg is a wonderful touch too.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("Makes 2½ cups, or 4 servings")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("3 eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("2 cups whole milk")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("2 tablespoons sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("2 tablespoons tupelo honey")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("2 tablespoons molasses")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("½ teaspoon vanilla extract")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_vm._v("¼ teaspoon ground cinnamon")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred"
  }, [_c('span', {
    staticClass: "pink"
  }, [_c('span', {
    staticClass: "super"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "sub"
  }, [_vm._v("8")]), _vm._v(" teaspoon freshly ground nutmeg")])]), _vm._v(" "), _c('p', {
    staticClass: "method"
  }, [_vm._v("Combine the eggs, milk, sugar, honey, molasses, vanilla, cinnamon, and nutmeg in a blender and process until smooth. Chill before serving. ")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "honey"
    }
  }), _c('img', {
    staticClass: "_idGenPageitem-1",
    attrs: {
      "alt": "",
      "src": "image/iStock_000008037657Medium.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6963d730","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/52249txt-1.vue
// module id = 63
// module chunks = 0